import { get } from "lodash";

import BaseService from './BaseService';
import LocalStorageService from '../services/LocalStorageService';

class OfferService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/v2/generic/all/offerTemplate";
	}

	find(code) {
   const currentCustomer = LocalStorageService.getCurrentCustomer();

    return (
      currentCustomer != null
        ? this.opencellAPI
        : this.opencellAPI_selfWS
    )
      .invokeRequest(
        {
          filters: {
            code
          },
          nestedEntities: [
            "offerServiceTemplates",
            "channels"
          ]
        },
        this.serviceUrl,
        "POST"
      )
      .then(response => {
        const offerTemplate = get(response, 'data[0]');

        if (!offerTemplate) {
          throw new Error(`Not found offerTemplate with code ${code}`)
        }

        return {
          actionStatus: {
            status: "SUCCESS"
          },
          offerTemplate
        }
      })
  }
 }

const offerService = new OfferService();

export default offerService;



// WEBPACK FOOTER //
// ./src/opencell/services/OfferService.js